// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bool-wrapper[data-v-60c3f292]{gap:12px;height:60px}.bi-cb[data-v-60c3f292]{padding:absolute;top:-9999px;left:-9999px;height:0;width:0}.si-cb[data-v-60c3f292]{width:40px;height:40px;background:#f5f8fc}.si-cb i[data-v-60c3f292]{height:34px;width:34px}.si-cb.si-alt[data-v-60c3f292]{background:#fff}.si-cb.checked[data-v-60c3f292]{background:var(--theme-color)}.si-cb .cb-desc[data-v-60c3f292]{word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
